import { FC, useState } from 'react';
import { createRoot } from 'react-dom/client';
import ComponentBackground from "GeneralComponents/ComponentBackground";
import CustomLinkButton from "GeneralComponents/CustomLinkButton";

import { BackColor } from "Interfaces/general.interface";
import { Link } from "Interfaces/general.interface";
import Consts from "Interfaces/Consts";
import './CallToAction.css';
import Helper from '../../Interfaces/Helper';

type Props = {
    disptitle: string;
    actionBtn: string;
    componentId: string;
    bgImgOpacity: string;
    BackColor: string;
    componentBGImage: string;
    componentBGMobileImage: string;
    currentPageId: string;
}

const CallToAction: FC<Props> = (props) => {

    const { componentBGImage, componentBGMobileImage, bgImgOpacity, componentId } = props;
    const dir = getComputedStyle(document.documentElement).direction;
    const disptitle = props.disptitle || '';
    const actionBtn = Helper.convertServerLinkItemToClientLinkItem(props.actionBtn);
    const BackGround: BackColor = getBackColor(props.BackColor);

    const [lightBg, setLightBg] = useState(true);

    function getBackColor(propsBackColor: string) {
        const defaultBgColor = {
            Color: {
                id: 1,
                label: "FFFFFF",
                value: "#FFFFFF"
            },
            Type: "light"
        };
        if (propsBackColor) return JSON.parse(propsBackColor);

        return defaultBgColor
            
    }

    function getBtnStyle(bgType: string){
       
        let btnStyle = (bgType == "dark") ? "btn-outline-primary" : "btn-primary";

        return btnStyle;
    }

    return (
           
        <ComponentBackground
            componentId={"CallToAction-" + componentId}
            bgImage={componentBGImage}
            bgMobileImage={componentBGMobileImage}
            bgImgOpacity={bgImgOpacity}
            backGround={BackGround}
            setLightBg={setLightBg}
            viewName="CallToAction"                
        >
            <div className="container z-1">
                {
                    disptitle.trim() != "" &&
                    <div className="row">
                        <div className="col-lg-12 text-center mb-3">
                            <h3 className="h3 assistant-bold text-center txt-30" dangerouslySetInnerHTML={{ __html: disptitle }}></h3>
                        </div>
                    </div>
                }
                <div className="row text-center ">
                    <div className="col-lg-12 text-center ">
                        {
                            props.actionBtn &&                              
                                    
                                <CustomLinkButton
                                    title={disptitle}
                                    pageUrl={""}
                                    link={actionBtn}
                                    isBtn={true}
                                    btnClass={"btn mst-btn " + getBtnStyle(BackGround.Type) + " mst-btn-round px-3 px-md-4 "}
                                    linkClass={""}
                                    dir={dir}
                                    linkIcon={false}
                                    extraAriaContext={disptitle}
                                />                                  
                        }  
                    </div>
                </div>
            </div>
        </ComponentBackground>
    );
}


var elements = document.querySelectorAll('[id^="CallToAction-"]');


for (var i = 0; i < elements.length; i++) {

    var rootElement = document.getElementById(elements[i].id);
    var root = createRoot(rootElement);
    root.render(
        <CallToAction
            currentPageId={rootElement.getAttribute('component-currentPageId')}
            componentId={rootElement.getAttribute('component-id')}
            disptitle={rootElement.getAttribute('component-title')}       
            actionBtn={rootElement.getAttribute('component-button')}          
            componentBGImage={rootElement.getAttribute('component-bgImage')}
            componentBGMobileImage={rootElement.getAttribute('component-bgMobileImage')}
            bgImgOpacity={rootElement.getAttribute('component-bgImgOpacity')}
            BackColor={rootElement.getAttribute('component-backColor')}
        />);

}

